import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ErrormessageModule } from '../../validation/errormessage/errormessage.module';

import { PCPTradePartnerAutoCompleteComponent } from "./pcp-tradepartner-autocomplete.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        AutoCompleteModule,
        PCPTradePartnerAutoCompleteComponent,
    ],
    exports: [PCPTradePartnerAutoCompleteComponent]
})
export class PCPTradePartnerAutoCompleteModule { }
